import { render, staticRenderFns } from "./appoint_proofreading.vue?vue&type=template&id=db93e392&scoped=true&"
import script from "./appoint_proofreading.vue?vue&type=script&lang=js&"
export * from "./appoint_proofreading.vue?vue&type=script&lang=js&"
import style0 from "./appoint_proofreading.vue?vue&type=style&index=0&id=db93e392&lang=less&scoped=true&"
import style1 from "./appoint_proofreading.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db93e392",
  null
  
)

export default component.exports